export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6412.4bc279a9.jpg";